import React from 'react';
import { useTheme } from '@mui/material';

export function ViiluLogo({ height = 30, ...props }) {
  const theme = useTheme();
  const textColor = theme.palette.mode === 'dark' ? '#ffffff' : '#000000';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="40 45 490 120"
      height={height}
      style={{ width: 'auto', display: 'block' }}
      {...props}
    >
      <path
        fill="#7b78ff"
        d="M98.3,57.97c.34,0,.62.28.62.62v41.53c0,1.2,1.61,1.6,2.17.54l22.4-42.36c.11-.2.32-.33.55-.33h38.49c1.3,0,2.36,1.06,2.36,2.36v44.48c0,.1-.03.2-.07.29l-23.78,45.17c-.55,1.04-1.63,1.69-2.8,1.69h-38.69c-.34,0-.62-.28-.62-.62v-43.28c0-1.71-1.39-3.1-3.1-3.1h-43.27c-.34,0-.62-.28-.62-.62v-45.76c0-.34.28-.62.62-.62h45.75Z"
      />
      <polygon
        fill={textColor}
        points="245.48 151.97 218.85 151.97 186.02 59.16 212.52 59.16 232.94 123.4 254.01 59.16 278.57 59.16 245.48 151.97"
      />
      <rect fill={textColor} x="284.69" y="59.16" width="24.43" height="92.81" />
      <rect fill={textColor} x="324.53" y="59.16" width="24.43" height="92.81" />
      <polygon
        fill={textColor}
        points="364.36 151.97 364.36 59.16 388.79 59.16 388.79 129.86 427.83 129.86 427.83 151.97 364.36 151.97"
      />
      <path
        fill={textColor}
        d="M515,115c0,22.49-14.09,38.91-40.2,38.91s-40.33-16.42-40.33-38.91v-55.84h24.43v56.23c0,9.69,3.49,16.67,15.9,16.67s15.77-6.98,15.77-16.67v-56.23h24.43v55.84Z"
      />
    </svg>
  );
}

export function ViiluIcon({ size = 32, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 68 55"
      fill="none"
      style={{ display: 'block' }}
      {...props}
    >
      <path
        d="M27.535 -0.000114441C27.7385 -0.000114441 27.9034 0.162006 27.9034 0.362072V24.607C27.9034 25.3073 28.8569 25.5401 29.1902 24.9209L42.4889 0.19305C42.5529 0.0740471 42.6784 -0.000114441 42.8143 -0.000114441H65.6705C66.4451 -0.000114441 67.0723 0.616467 67.0723 1.37792V27.3459C67.0723 27.4045 67.0573 27.4623 67.0301 27.514L52.9113 53.883C52.5868 54.4901 51.9456 54.8704 51.2474 54.8704H28.271C28.0675 54.8704 27.9034 54.7082 27.9034 54.5082V29.2439C27.9034 28.2453 27.0789 27.4347 26.0631 27.4347H0.368408C0.164907 27.4347 0 27.2734 0 27.0734V0.362072C0 0.162006 0.164907 -0.000114441 0.368408 -0.000114441H27.535Z"
        fill="#7B78FF"
      />
    </svg>
  );
}